var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarth2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 809,
    height: 809,
    viewBox: "0 0 809 809",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 404.5,
    cy: 404.5,
    r: 404.5,
    fill: "#3F0099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth2);
export default __webpack_public_path__ + "static/media/earth_2.de80828654f167428b3b690ab39810cd.svg";
export { ForwardRef as ReactComponent };